/* eslint-disable no-tabs */
import styled from 'styled-components';

const ResetCss = styled.div` 
  	&.App > html,
	&.App > body,
	&.App > div,
	&.App > span,
	&.App > applet,
	&.App > object,
	&.App > iframe,
	&.App > h1,
	&.App > h2,
	&.App > h3,
	&.App > h4,
	&.App > h5,
	&.App > h6,
	&.App > p,
	&.App > blockquote,
	&.App > pre,
	&.App > a,
	&.App > abbr,
	&.App > acronym,
	&.App > address,
	&.App > big,
	&.App > cite,
	&.App > code,
	&.App > del,
	&.App > dfn,
	&.App > em,
	&.App > img,
	&.App > ins,
	&.App > kbd,
	&.App > q,
	&.App > s,
	&.App > samp,
	&.App > small,
	&.App > strike,
	&.App > strong
	&.App > sub,
	&.App > sup,
	&.App > tt,
	&.App > var,
	&.App > b,
	&.App > u,
	&.App > i,
	&.App > center,
	&.App > dl,
	&.App > dt,
	&.App > dd,
	&.App > menu,
	&.App > ol,
	&.App > ul,
	&.App > li,
	&.App > fieldset,
	&.App > form,
	&.App > label,
	&.App > legend,
	&.App > table,
	&.App > caption,
	&.App > tbody,
	&.App > tfoot,
	&.App > thead,
	&.App > tr,
	&.App > th,
	&.App > td,
	&.App > article,
	&.App > aside,
	&.App > canvas,
	&.App > details,
	&.App > embed,
	&.App > figure,
	&.App > figcaption,
	&.App > footer,
	&.App > header,
	&.App > hgroup,
	&.App > main,
	&.App > menu,
	&.App > nav,
	&.App > output,
	&.App > ruby,
	&.App > section,
	&.App > summary,
	&.App > time,
	&.App > mark,
	&.App > audio,
	&.App > video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	&.App > article,
	&.App > aside,
	&.App > details,
	&.App > figcaption,
	&.App > figure,
	&.App > footer,
	&.App > header,
	&.App > hgroup,
	&.App > main,
	&.App > menu,
	&.App > nav,
	&.App > section {
		display: block;
	}
	/* HTML5 hidden-attribute fix for newer browsers */
	&.App > *[hidden] {
			display: none;
	}
	&.App > body {
		line-height: 1;
	}
	&.App > menu,
	&.App > ol,
	&.App > ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	&.App > blockquote:before,
	&.App > blockquote:after,
	&.App > q:before,
	&.App > q:after {
		content: '';
		content: none;
	}
	&.App > table {
		border-collapse: collapse;
		border-spacing: 0;
	}
`;

export default ResetCss;
